import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React from "react";

function ConfirmationModal(props) {
  const { heading, paragraph, handleClose } = props;
  return (
    <>
      <Modal
        id="change_gender"
        className="custom-modal1 custom-modal2 custom-modal3"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <h4>{heading}</h4>
          <i
            className="fa-solid fa-xmark"
            onClick={() => {
              handleClose("Hide");
            }}
          ></i>
        </Modal.Header>

        <Modal.Body>
          <div className="modal-tab-block">
            <p>{paragraph}</p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={() => {
              handleClose("noThanks");
            }}
          >
            No Thanks
          </Button>
          <Button
            onClick={() => {
              handleClose("delete");
            }}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
